module.exports = "/_next/static/images/e8f0177c36a233819d4f64538aa1741b-press-hero-desktop.jpg";